import { TagRequest, TagRequestTagType } from '@/api-client/data/model';
import { GridLayoutItem, WidgetTarget } from '@/dashboard/shared/types/widgets.types';
import { RequestTagWithWidgetInfo } from '@/dashboard/stores/dashboard-targets';
import { FIXED_DATA_ID, FIXED_DATA_ID_BY_CHART_TYPE } from '../constants/define';

const getAllRequestTags = (targets: WidgetTarget[]): TagRequest[] => {
  const requestTargets: Map<string, TagRequest> = new Map();

  targets.forEach(({ tagKey, tagValue, tagType }) => {
    const existingTagRequest = requestTargets.get(tagKey);

    if (existingTagRequest) {
      existingTagRequest.tagValue?.push(tagValue);
    } else {
      requestTargets.set(tagKey, {
        tagKey,
        tagType: tagType as TagRequestTagType,
        tagValue: [tagValue],
      });
    }
  });

  return Array.from(requestTargets.values());
};

/**
 * GridLayoutItem에서 모든 request tags를 재귀적으로 수집
 * @param items - GridLayoutItem 배열
 * @param acc - 누적 배열 (옵션)
 */
export const getAllRequestTagsRecursively = (
  items: GridLayoutItem[],
  acc: RequestTagWithWidgetInfo[] = [],
): RequestTagWithWidgetInfo[] => {
  items.forEach(
    ({
      children,
      chartData,
      i,
      titleOption,
      widgetType,
      chartType,
      displayStyle,
      chartOption,
      isInViewport,
      timePeriod,
      calendarTimeRange,
    }) => {
      if (children?.length) {
        getAllRequestTagsRecursively(children, acc);
      }

      let refinedChartData = chartData;
      if (chartOption?.settingsMode === 'simple') {
        refinedChartData = chartData?.slice(0, 1);
      }

      refinedChartData?.forEach(
        ({ id, targets, categories, category, dataId, value }, chartDataIndex) => {
          if (value?.isShow === false) {
            return;
          }

          const mergedTargets = getAllRequestTags(targets);
          const isAlertScoreboard =
            widgetType === 'ALERT' &&
            (displayStyle === 'SCOREBOARD' || displayStyle === 'SCOREBOARD_TABLE');

          const resolvedDataId = isAlertScoreboard
            ? FIXED_DATA_ID.ALERT_COUNT
            : (FIXED_DATA_ID_BY_CHART_TYPE[chartType] ?? dataId);

          const compareDateOption =
            chartType === 'ONE_DAY_COMPARE' ? chartOption?.compareDate : undefined;

          const widgetInfo = {
            uuid: i,
            name: titleOption.titleText,
            chartType,
            displayStyle,
            isInViewport,
            timePeriod,
            calendarTimeRange,
            compareDateOption,
          };
          const alertCategories = widgetType === 'ALERT' ? { categories } : {};

          acc.push({
            widget: widgetInfo,
            chartData: {
              id,
              index: chartDataIndex,
              category,
              dataId: resolvedDataId,
              targets: mergedTargets,
              ...alertCategories,
            },
            referenceInfo: chartOption?.referenceInfo,
          });

          if (displayStyle === 'SCOREBOARD_TABLE') {
            acc.push({
              widget: widgetInfo,
              chartData: {
                id,
                index: chartDataIndex,
                category,
                dataId: FIXED_DATA_ID_BY_CHART_TYPE[chartType] ?? dataId,
                targets: mergedTargets,
                ...alertCategories,
              },
              referenceInfo: chartOption?.referenceInfo,
            });
          }
        },
      );
    },
  );
  return acc;
};
